import { useMemo } from 'react'
import { useDesignTokenValue } from 'Simple/DesignTokens'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let lineColor = useDesignTokenValue({
    viewPath: props.viewPath,
    path: 'colors.neutral.300',
  })
  let dotColor = useDesignTokenValue({
    viewPath: props.viewPath,
    path: 'colors.neutral.400',
  })

  return useMemo(() => {
    return {
      ...data,
      lineColor: lineColor,
      dotColor: dotColor,
      tagType: 'grey',
      ...props,
    }
  }, [props, data, lineColor, dotColor])
}
